












import { Component, Prop, Vue } from 'nuxt-property-decorator';
import UniversalSearchResults from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResults.vue';
import type { SearchQuery } from '@/types/graphql';

@Component<UniversalSearchHistory>({
  components: {
    UniversalSearchResults,
  },
})
export default class UniversalSearchHistory extends Vue {
  @Prop({ default: [] }) history!: SearchQuery[];

  get results() {
    return this.history.map(item => ({ ...item.searchResult, queryId: item.id }));
  }
}
